export const getFullAddress = (street: string, zipCode: string, city: string, name?: string) =>
   name ? `${name} ${street}, ${zipCode} ${city}` : `${street}, ${zipCode} ${city}`;
